// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"580":"qtc-react-brightcove","634":"qtc-react-dailymotion","1701":"firebase-app","3093":"list","3180":"story","3435":"firebase-messaging","5177":"home","8946":"qtc-parsecsv"}[chunkId] || chunkId) + "-" + __webpack_require__.h().slice(0, 20) + ".js";
};